import { Box, Typography } from "@mui/material";

export const StatusBox = ({ status, customStatus }) => {
    const displayStatus = customStatus || status;
    
    if (!displayStatus) {
        return (
            <Box
                sx={{
                    display: 'inline-block',
                    padding: '6px 16px',
                    borderRadius: '16px',
                    backgroundColor: 'transparent',
                    border: '1px solid #ddd',
                    minWidth: '80px',
                    textAlign: 'center',
                }}
            >
                <Typography variant="body2" sx={{ color: '#666', fontSize: '12px' }}>
                    Sem status
                </Typography>
            </Box>
        );
    }

    return (
        <Box
            sx={{
                display: 'inline-block',
                padding: '6px 16px',
                borderRadius: '16px',
                backgroundColor: 'transparent',
                border: `1px solid ${displayStatus.hex_color || '#ddd'}`,
                color: displayStatus.hex_color || '#666',
                minWidth: '80px',
                textAlign: 'center',
            }}
        >
            <Typography 
                variant="body2" 
                sx={{ 
                    fontSize: '12px',
                    fontWeight: 500,
                    color: 'inherit'
                }}
            >
                {displayStatus.name}
            </Typography>
        </Box>
    );
};

